import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';
import { observer } from 'mobx-react';
import memoize from 'memoizee';
import SuggestedDocuments from '../../../../../../../documents/components/SuggestedDocumentsList';
import { outerJoin } from '../../../../../../../utils/arrayUtil';
import DownloadIcon from './prompt-upload-dialog.i.svg';
var DocumentsInput = function DocumentsInput(_ref) {
  var _vm$prompt$question$a, _vm$currentWorkInProg;
  var vm = _ref.vm,
    disabled = _ref.disabled,
    onChange = _ref.onChange;
  var _vm$rootStore = vm.rootStore,
    documentStore = _vm$rootStore.documentStore,
    documentVersionStore = _vm$rootStore.documentVersionStore,
    documentAccessStore = _vm$rootStore.documentAccessStore;
  var fetchDocument = React.useCallback(memoize(documentStore.fetchDocument.bind(documentStore), {
    promise: true,
    length: 1
  }), []);
  var items = outerJoin((_vm$prompt$question$a = vm.prompt.question.answer) !== null && _vm$prompt$question$a !== void 0 ? _vm$prompt$question$a : ((_vm$currentWorkInProg = vm.currentWorkInProgress) !== null && _vm$currentWorkInProg !== void 0 ? _vm$currentWorkInProg : []).map(function (w) {
    return {
      id: w.id,
      documentId: w.document_id
    };
  }), 'id', vm.prompt.question.options, 'id');
  var addToAnswer = function addToAnswer(item, doc) {
    var _vm$answer;
    var mapped = [].concat(_toConsumableArray(((_vm$answer = vm.answer) !== null && _vm$answer !== void 0 ? _vm$answer : []).filter(function (a) {
      return a.id !== item.id;
    })), [{
      id: item.id,
      document_id: doc.id
    }]);
    onChange(mapped);
  };
  var removeFromAnswer = function removeFromAnswer(item) {
    var mapped = _toConsumableArray(vm.answer.filter(function (a) {
      return a.id !== item.id;
    }));
    onChange(mapped.length > 0 ? mapped : null);
  };
  var uploadDocument = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(item, file, receiveDocument) {
      var doc;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return documentStore.createDocument({
              title: item.text,
              tags: (item.tagIds || []).slice(),
              workspace_id: vm.prompt.workspaceId,
              access: {
                type: 'Job',
                job_id: vm.prompt.jobId
              }
            });
          case 2:
            doc = _context.sent;
            receiveDocument(doc);
            _context.next = 6;
            return documentVersionStore.createVersion({
              message: 'Initial Version',
              document_id: doc.id,
              action: {
                type: 'ReplaceContents',
                files: [file]
              }
            });
          case 6:
            addToAnswer(item, doc);
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function uploadDocument(_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
  var linkDocument = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(item, doc) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!doc.accesses.some(function (a) {
              return a.type === 'Job' && a.jobId === vm.prompt.jobId;
            })) {
              _context2.next = 3;
              break;
            }
            // Already linked to job.
            addToAnswer(item, doc);
            return _context2.abrupt("return");
          case 3:
            _context2.next = 5;
            return documentAccessStore.createAccess(doc.id, {
              access: {
                type: 'Job',
                job_id: vm.prompt.jobId
              }
            });
          case 5:
            addToAnswer(item, doc);
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function linkDocument(_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }();
  var unlinkDocument = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(item, doc) {
      var access;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            access = doc.accesses.find(function (x) {
              return x.type === 'Job' && x.jobId === vm.prompt.jobId;
            });
            if (!access) {
              _context3.next = 4;
              break;
            }
            _context3.next = 4;
            return documentAccessStore.deleteAccess(access.id);
          case 4:
            removeFromAnswer(item);
          case 5:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function unlinkDocument(_x6, _x7) {
      return _ref4.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(SuggestedDocuments, {
    documentStore: documentStore,
    fetchDocument: fetchDocument,
    value: items,
    uploadIcon: DownloadIcon,
    finishedIcon: DownloadIcon,
    disabled: disabled,
    readOnly: !vm.prompt.isPendingResponse,
    uploadDocument: uploadDocument,
    linkDocument: linkDocument,
    unlinkDocument: unlinkDocument
  });
};
export default observer(DocumentsInput);
//# sourceMappingURL=index.js.map
